export const MASK_CNPJ = '**.***.***/****-99';

export const CNPJ_FORMAT_CHARS = {
  9: '[0-9]',
  a: '[A-Za-z]',
  '*': '[A-Za-z0-9]',
};

export const CNPJ_FORMATTED_REGEX =
  /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/i;

export const sanitizeCnpj = (value = '') =>
  String(value ?? '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase();

export const cleanCnpj = sanitizeCnpj;

export const formatCnpjInput = (value = '') =>
  sanitizeCnpj(value)
    .slice(0, 14)
    .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
    .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
    .replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2')
    .replace(/([A-Z0-9]{4})([0-9])/, '$1-$2');

export const formatCnpj = (value = '') => {
  if (!value) return '';

  const normalized = sanitizeCnpj(value);

  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(normalized)) return String(value);

  return formatCnpjInput(normalized);
};

export const isValidCnpj = (value) => {
  const cnpj = sanitizeCnpj(value);

  if (
    cnpj.length !== 14 ||
    !/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj) ||
    /^([A-Z0-9])\1{13}$/.test(cnpj)
  ) {
    return false;
  }

  const calculateDigit = (base) => {
    let sum = 0;
    let weight = base.length - 7;

    for (let index = 0; index < base.length; index += 1) {
      sum += (base.charCodeAt(index) - 48) * weight;
      weight -= 1;
      if (weight < 2) weight = 9;
    }

    return sum % 11 < 2 ? 0 : 11 - (sum % 11);
  };

  const base = cnpj.slice(0, 12);
  const firstDigit = calculateDigit(base);

  if (firstDigit !== Number(cnpj.charAt(12))) return false;

  return calculateDigit(`${base}${firstDigit}`) === Number(cnpj.charAt(13));
};
